import { queryOptions, useQuery } from '@tanstack/react-query';

import { QueryKeys } from '@/network/query.types';

import { client, unwrapResponse } from '../client';

export const fetchTyreProductQueryOptions = (
  slug: string,
  query: {
    sup?: string;
  },
) =>
  queryOptions({
    queryKey: [QueryKeys.tyreProduct, slug, query],
    queryFn: () =>
      client
        .GET(`/api/v1/tyres/product/{slug}`, {
          params: {
            path: {
              slug,
            },
            query,
          },
        })
        .then(unwrapResponse),
  });

const fetchTyreProductSalesQueryOptions = (sku: string) =>
  queryOptions({
    queryKey: [QueryKeys.tyreProductSales, sku],
    queryFn: () => client.GET('/api/v1/tyres/product/{sku}/sales', { params: { path: { sku } } }).then(unwrapResponse),
  });

export function useTyreProductQuery(
  slug: string,
  query: {
    sup?: string;
  },
) {
  return useQuery({
    ...fetchTyreProductQueryOptions(slug, query),
    refetchOnWindowFocus: true,
  });
}

export function useTyreProductSalesQuery(sku: string) {
  return useQuery({
    ...fetchTyreProductSalesQueryOptions(sku),
    staleTime: 60 * 60 * 1000,
  });
}
